module.exports = __webpack_public_path__ + "img/award_silver.2eca3be8.svg";